import React, { useEffect, useState } from "react";
import "../css/app.css";
import AppContext from "../context/AppContext";
import { useContext } from "react";
import ApiService from "../api/ApiService";
import { useTranslation } from "react-i18next";
import CommonProgressBar from "../components/common/progressBar";
import GBCDashboard from "../components/dashboards/gbcDashboard";
import TempleDashboard from "../components/dashboards/templeDashboard";
import RSADashboard from "../components/dashboards/RSADashboard";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NotificationComponent from "../components/common/pushNotify";
import { Modal } from "react-bootstrap";
import MobileSafeDatePicker from "../components/common/MobileSafeDatePicker";
import TopPosterBanner from "../components/common/TopPosterBanner";

const Dashboard = () => {
  const { t, i18n } = useTranslation();

  // Event tabs
  const selectTabs = [
    {
      label: t("Overall Book Distribution"),
      value: "Regular Update",
      description: t(
        "Overall Book Distribution refers to year-round distribution and includes all marathons"
      ),
    },
    {
      label: t("Bhadra Purnima Marathon"),
      value: "Bhadra Purnima",
      description: t(
        "Bhadra Purnima Marathon refers to SB set distribution from Gaura Purnima till Bhadra Purnima"
      ),
    },
    {
      label: t("Chaitanya Charitamrita Marathon"),
      value: "Chaitanya Charitamrita",
      description: t(
        "Chaitanya Charitamrita Marathon refers to CC set distribution from 15th Jan till Gaura Purnima"
      ),
    },
    {
      label: t("Gita Marathon"),
      value: "Gita Marathon",
      description: t(
        "December Bhagavad Gita Marathon refers to book distribution between 15th Nov to 15th Jan"
      ),
    },
  ];

  const tooltip = (description) => {
    return <div className="tooltip-custom">{t(description)}</div>;
  };

  const { user } = useContext(AppContext);
  const [userEventRanking, setUserEventRanking] = useState({});
  const [previousYearUserEventRanking, setPreviousYearUserEventRanking] =
    useState({});
  const [pledgeCountsFromDB, setPledgeCountFromDB] = useState([]);
  const [animatedPercentage, setAnimatedPercentage] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(selectTabs[0].value);
  const [userBooksStatsData, setUserBooksStatsData] = useState([]);
  const [overAllPointsCount, setOverAllPointsCount] = useState([]);
  const [topTemplesList, setTopTemplesList] = useState([]);
  const [indiaPledgeData, setIndiaPledgeData] = useState({});
  const [RSATempleList, setRSATempleList] = useState([]);
  const [monthlyPoints, setMonthlyPoints] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [filteredSchedules, setFilteredSchedules] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [filterTemple, setFilterTemple] = useState("");
  // const [filterType, setFilterType] = useState(null); // 'date' | 'temple' | null
  const [sankirtanaData, setSankirtanaData] = useState({});
  const [sankirtanaDataAllTemples, setSankirtanaDataAllTemples] = useState({});

  const [sankirtanaFilterDate, setSankirtanaFilterDate] = useState("");
  const [sankirtanaFilterDateAll, setSankirtanaFilterDateAll] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  console.log("Schedule", schedules);

  // Temple Total Pledge
  const getPledgeCountData = async (user) => {
    setAnimatedPercentage(0);

    try {
      let res = [];

      // Pass user.id and isTemple = false
      res = await ApiService.fetchPledgeCountForDB(
        user.id,
        "Regular Update",
        false,
        user.temple_id,
        new Date().getFullYear() // Pass current year
      );
      console.log("Pledge Count", res);

      const accumulatedData = {};

      res.forEach((item) => {
        const { book_name, count_book } = item;

        if (accumulatedData[book_name]) {
          accumulatedData[book_name].count_book += parseInt(count_book);
        } else {
          accumulatedData[book_name] = {
            ...item,
            count_book: parseInt(count_book),
          };
        }
      });

      const accumulatedArray = Object.values(accumulatedData);
      // setUserPledgedData(accumulatedArray); // Uncomment if needed

      let totalPledgeCount = 0;

      if (res && res.length > 0) {
        totalPledgeCount = res.reduce(
          (acc, curVal) => acc + Number(curVal.count_book),
          0
        );
      }

      setPledgeCountFromDB(totalPledgeCount);
    } catch (error) {
      console.log(error);
    }
  };

  // Temple previous year ranking
  const fetchPreviousYearRankingByUserId = async (user) => {
    setPreviousYearUserEventRanking({});
    try {
      let res;

      if (user) {
        res = await ApiService.fetchUserPreviousYearRanking(
          user.temple_id,
          user.zone_name,
          user.temple,
          user.state_id,
          selectedEvent
        );
        setPreviousYearUserEventRanking(res);
      } else {
        throw new Error("User ID is required");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Temple Current year ranking
  const fetchCurrentYearByUserId = async (user) => {
    try {
      let res;

      if (user) {
        res = await ApiService.fetchDataFromAllLiveRankingByUserId(
          user.temple_id,
          user.zone_name,
          user.temple_id,
          user.state_id,
          "Regular Update"
        );
        setUserEventRanking(res);
        console.log("USEREVENTRANKING", res);
      } else {
        throw new Error("User ID is required");
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Current and Previous Year Books Graph
  const getCurrentAndPreviousYearBooks = async () => {
    setUserBooksStatsData([]);

    try {
      let res = [];
      if (
        user?.role !== "Regional Zonal Secretary" &&
        user?.role !== "Regional Secretary Assistant"
      ) {
        res = await ApiService.getCurrentAndPreviousBooksCount(
          user.temple_id,
          selectedEvent
        );
      } else {
        const postData = {
          temple_array: user.temple_array,
          state_array: user.state_array,
          zone_array: user.zone_array,
          event: selectedEvent,
        };

        res = await ApiService.getRSACurrentAndPreviousBooksCount(postData);
      }

      const resultData = res.data;

      //for over all book count
      if (
        selectedEvent == "Regular Update" ||
        selectedEvent == "Gita Marathon"
      ) {
        const booksCountArray = [
          {
            name: "ChaitanyaCharitamritaSet",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "SrimadBhagavatamSet",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "MahabigBooks",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "BigBooks",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "MediumBooks",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "SmallBooks",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "SrilaPrabhupadaLilamrita",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "Magazines",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "1 Year BTG Subscription-1",
            lastYearScore: "0",
            currentScore: "0",
          },
          {
            name: "1 Year BTG Subscription-2",
            lastYearScore: "0",
            currentScore: "0",
          },
        ];

        const existingItemsMap = new Map(
          resultData.map((item) => [item.name, item])
        );

        const updatedData = [];

        booksCountArray.forEach((item) => {
          if (existingItemsMap.has(item.name)) {
            updatedData.push(existingItemsMap.get(item.name));
          } else {
            updatedData.push(item);
          }
        });
        setUserBooksStatsData(updatedData);
      } else {
        if (resultData.length > 0) {
          setUserBooksStatsData(resultData);
        } else if (selectedEvent == "Chaitanya Charitamrita") {
          setUserBooksStatsData([
            {
              name: "ChaitanyaCharitamritaSet",
              lastYearScore: "0",
              currentScore: "0",
            },
          ]);
        } else {
          setUserBooksStatsData([
            {
              name: "SrimadBhagavatamSet",
              lastYearScore: "0",
              currentScore: "0",
            },
          ]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Current and Previous Year Points Graph
  const getCurrentAndPreviousYearPointsCount = async () => {
    setOverAllPointsCount([]);

    try {
      let res = [];

      if (
        user?.role !== "Regional Zonal Secretary" &&
        user?.role !== "Regional Secretary Assistant"
      ) {
        res = await ApiService.getCurrentAndPreviousPointsCount(
          user.temple_id,
          selectedEvent
        );
      } else {
        const postData = {
          temple_array: user.temple_array,
          state_array: user.state_array,
          zone_array: user.zone_array,
          event: selectedEvent,
        };
        res = await ApiService.getRSACurrentAndPreviousPointsCount(postData);
      }

      const resultData = res.data;

      if (resultData.length > 0) {
        const totalPointsObj = { currentScore: 0, lastYearScore: 0 };
        resultData.map((v, i) => {
          totalPointsObj["lastYearScore"] += Number(v.lastYearScore);
          totalPointsObj["currentScore"] += Number(v.currentScore);
        });

        // totalPointsObj.lastYearScore = Math.ceil(totalPointsObj.lastYearScore).toLocaleString("en-IN");
        // totalPointsObj.currentScore = Math.ceil(totalPointsObj.currentScore).toLocaleString("en-IN");

        setOverAllPointsCount([totalPointsObj]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Top 10 Temples
  const getTopTenTemplesList = async () => {
    setTopTemplesList([]);
    try {
      const res = await ApiService.getTopTemplesList(selectedEvent, "all");

      if (res.status && res.data?.length > 0) {
        setTopTemplesList(res.data);
      } else {
        console.log("No temples found");
      }
    } catch (error) {
      console.error("Error fetching top temples:", error);
    }
  };

  // India Pledge
  const getIndiaPledgeData = async () => {
    setIndiaPledgeData({});
    try {
      const res = await ApiService.getOverAllIndiaPledgeStatus(
        "Regular Update"
      );
      if (res.status) {
        let indiaPledgePercentage = 0;

        if (
          res?.data?.total_count_book_for_pledge > 0 &&
          res?.data?.total_count_book_for_pledge > 0
        ) {
          indiaPledgePercentage = Math.floor(
            (res?.data?.total_count_book_for_score /
              res?.data?.total_count_book_for_pledge) *
            100
          );
        }

        const indiaPledgeObj = {
          ...res.data,
          india_pledge_percentage: indiaPledgePercentage,
        };

        setIndiaPledgeData(indiaPledgeObj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //RSA Temples list
  const getRSAAllTempleList = async (user) => {
    if (user.temple_array != null && user.temple_array.length > 0) {
      setRSATempleList(user.temple_array);
    } else {
      try {
        const postData = {
          state_array: user.state_array,
          zone_array: user.zone_array,
        };

        const res = await ApiService.getRSATempleList(postData);

        if (res) {
          setRSATempleList(res);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    setAnimatedPercentage("");
    if (pledgeCountsFromDB > 0 && userEventRanking.count_book > 0) {
      const percentage = Math.floor(
        (userEventRanking.count_book / pledgeCountsFromDB) * 100
      );

      setAnimatedPercentage(percentage);
    } else {
      setAnimatedPercentage(0);
    }
  }, [pledgeCountsFromDB, userEventRanking]);

  useEffect(() => {
    if (user?.role != "GBC (Governing Body Commission)") {
      getPledgeCountData(user);
      getCurrentAndPreviousYearBooks(user);
      getCurrentAndPreviousYearPointsCount(user);
      fetchCurrentYearByUserId(user);
      fetchPreviousYearRankingByUserId(user);
    }
    getTopTenTemplesList();
    getIndiaPledgeData();
  }, [user, selectedEvent]);

  useEffect(() => {
    if (
      user?.role == "Regional Zonal Secretary" ||
      user?.role == "Regional Secretary Assistant"
    ) {
      getRSAAllTempleList(user);
    }
  }, [user]);

  function getOrdinalSuffix(number) {
    const lastDigit = number % 10;

    const secondLastDigit = Math.floor(number / 10) % 10;

    if (secondLastDigit === 1) {
      return "th";
    } else {
      switch (lastDigit) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }
  }

  function displayOrdinal(number) {
    const suffix = getOrdinalSuffix(number);
    return `${number}${suffix}`;
  }

  useEffect(() => {
    const fetchMonthlyPoints = async () => {
      try {
        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;

        const response = await ApiService.getMonthlyPoints({
          year: `${currentYear},${previousYear}`,
          temple_id: user?.temple_id,
          event: selectedEvent,
        });

        const data = response?.data || [];
        setMonthlyPoints(data);

        // console.log("Current Year Data:", currentRes?.data);
        // console.log("Previous Year Data:", previousRes?.data);

        // const currentData = currentRes?.data || [];
        // const previousData = previousRes?.data || [];

        // // Add 'year' key to each point
        // const mergedData = [
        //   ...currentData.map((point) => ({ ...point, year: currentYear })),
        //   ...previousData.map((point) => ({ ...point, year: previousYear })),
        // ];

        // setMonthlyPoints(mergedData);
      } catch (err) {
        console.error("Failed to fetch monthly points:", err);
        setMonthlyPoints([]);
      }
    };

    if (user?.id && selectedEvent) {
      fetchMonthlyPoints();
    }
  }, [user?.id, selectedEvent]);

  const [yearlyPoints, setYearlyPoints] = useState([]);
  console.log("MNDNDND", yearlyPoints);

  useEffect(() => {
    const fetchYearlyPoints = async () => {
      try {
        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;

        const [currentRes, previousRes] = await Promise.all([
          ApiService.getYearlyPoints({
            year: currentYear,
            user_id: user?.id,
            event: selectedEvent,
            temple_id: user?.temple_id,
          }),
          ApiService.getYearlyPoints({
            year: previousYear,
            user_id: user?.id,
            event: selectedEvent,
            temple_id: user?.temple_id,
          }),
        ]);

        console.log("Previous Year Data:", previousRes);
        console.log("Current Year Data:", currentRes);

        // Assuming currentYearSum and previousYearSum are numbers, not arrays.
        const currentYearSum = currentRes?.currentYearSum || 0;
        const previousYearSum = previousRes?.previousYearSum || 0;

        // Prepare the data in the expected format for the GraphChart
        const mergedData = [
          {
            name: t("Yearly Comparison"),
            [currentYear]: currentYearSum,
            [previousYear]: previousYearSum,
          },
        ];

        // Set the merged data to state
        setYearlyPoints(mergedData);
      } catch (err) {
        console.error("Failed to fetch yearly points:", err);
        setYearlyPoints([]);
      }
    };

    if (user?.id && selectedEvent) {
      fetchYearlyPoints();
    }
  }, [user?.id, selectedEvent]);

  //fetching Upcoming Sankirtans
  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const response = await ApiService.getUpcomingSchedules();
        const data = response?.data || [];
        console.log("ScheduleResponse", response);
        setSchedules(data);
        setFilteredSchedules(data);
      } catch (err) {
        console.error("Error fetching schedules:", err);
      }
    };

    fetchSchedules();

    const interval = setInterval(() => {
      fetchSchedules();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const filtered = schedules.filter((item) => {
      console.log("Checking:", item.date, "vs", filterDate);
      const matchesDate = filterDate ? item.date === filterDate : true;
      const matchesTemple = filterTemple
        ? item.temple?.toLowerCase().includes(filterTemple.toLowerCase())
        : true;
      return matchesDate && matchesTemple;
    });

    setFilteredSchedules(filtered);
  }, [filterDate, filterTemple, schedules]);

  //converting to DD-MM-YY,HH:MM AM/PM format
  const formatDateTime = (dateStr, timeStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2); // Get last 2 digits
    const formattedDate = `${day}-${month}-${year}`;

    const formattedTime = convertTo12HourFormat(timeStr);

    return `${formattedDate}, ${formattedTime}`;
  };

  // Utility function to convert "14:30" → "2:30 PM"
  const convertTo12HourFormat = (timeStr) => {
    if (!timeStr) return "--:--";

    const [hourStr, minuteStr] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr;
    const ampm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    return `${hour}:${minute} ${ampm}`;
  };

  const getFilterType = () => {
    if (filterDate && !filterTemple) return "date";
    if (!filterDate && filterTemple) return "temple";
    if (filterDate && filterTemple) return "date-temple";
    return null;
  };

  const filterType = getFilterType();

  const fetchSankirtanaData = async () => {
    try {
      if (user) {
        const res = await ApiService.getSankirtanaData(user.temple_id);
        console.log("Sankirtana data", res);

        // FIX: Store only the array
        setSankirtanaData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchSankirtanaDataAll = async () => {
    try {
      if (user) {
        const res = await ApiService.getSankirtanaAll();
        console.log("Sankirtana data of All Temples", res);

        // FIX: Store only the array
        setSankirtanaDataAllTemples(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };





  useEffect(() => {
    fetchSankirtanaData();
    fetchSankirtanaDataAll();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); // store images for modal

  const handleOpenModal = (images) => {
    setSelectedImages(images); // pass the images for that row
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImages([]);
  };

  return (
    <div className="dashboard-container">
      <div className="container">
      <TopPosterBanner />  {/* 👈 ADD HERE */}
        <div className="notification-container">
          <NotificationComponent userId={user.id} />
        </div>
        {/* User Login stats*/}
        {user?.role != "GBC (Governing Body Commission)" && (
          <div className="row check-padding">
            <div className="col-md-4 welcome-left-div">
              <div className={"col-md-12 user-welcome-card "}>
                <p className="welcome-text-name">
                  {t("Welcome")}{" "}
                  {i18n.language === "hi" ? user?.hindiname : user?.name}
                </p>
                <p className="welcome-info-text">
                  {t(
                    "Explore the dashboard for detailed insights and current progress in Harinaam Sankirtan"
                  )}
                </p>
                {/* {user?.role == "Regional Zonal Secretary" ||
                  (user?.role == "Regional Secretary Assistant" && (
                    <>
                      <b className="text-dark">
                        {t("Your Temples")} -{" "}
                        {user.temple_array != null &&
                        user.temple_array.length > 0
                          ? user.temple_array.length
                          : RSATempleList.length}
                      </b>
                      <div className="card-text temple-list-card">
                        {user.temple_array != null &&
                        user.temple_array.length > 0 ? (
                          user.temple_array.map((item, i) => (
                            <p className="mt-1 temple-list" key={i}>
                              {i + 1}.{" "}
                              {i18n.language === "hi"
                                ? item.split(",")[3]
                                : item.split(",")[2]}
                            </p>
                          ))
                        ) : (
                          <>
                            {RSATempleList.length > 0 &&
                              RSATempleList.map((item, i) => (
                                <p className="mt-1 temple-list" key={i}>
                                  {i + 1}.{" "}
                                  {i18n.language === "hi"
                                    ? item.hinditempleName
                                    : item.templeName}
                                </p>
                              ))}
                          </>
                        )}
                      </div>
                    </>
                  ))} */}
              </div>
              {typeof userEventRanking.all_rank != "undefined" &&
                user.role != "Regional Zonal Secretary" &&
                user.role !== "Regional Secretary Assistant" && (
                  <div className="row col-md-12 wish-card user-welcome-card">
                    {/* Left Column */}
                    <div className="col-md-6 mb-4">
                      <div className="d-flex align-items-center mt-2">
                        {/* Harinaam Sankirtan SVG */}
                        <svg
                          width="71"
                          height="71"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.21"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
                            fill="#883DCF"
                          />
                          <path
                            d="M19.1111 40.8889H42.4444C43.3036 40.8889 44 41.5853 44 42.4444C44 43.3036 43.3036 44 42.4444 44H17.5556C16.6964 44 16 43.3036 16 42.4444V17.5556C16 16.6964 16.6964 16 17.5556 16C18.4147 16 19.1111 16.6964 19.1111 17.5556V40.8889Z"
                            fill="#883DCF"
                          />
                          <path
                            opacity="0.5"
                            d="M24.9126 34.175C24.325 34.8018 23.3406 34.8335 22.7138 34.2459C22.0871 33.6584 22.0553 32.674 22.6429 32.0472L28.4762 25.825C29.0445 25.2188 29.9888 25.1663 30.6208 25.7056L35.2248 29.6344L41.2235 22.0361C41.7558 21.3618 42.734 21.2467 43.4083 21.7791C44.0826 22.3114 44.1977 23.2896 43.6653 23.9639L36.6653 32.8306C36.1186 33.5231 35.1059 33.6227 34.4347 33.05L29.7306 29.0358L24.9126 34.175Z"
                            fill="#883DCF"
                          />
                        </svg>
                        <div className="mt-3" style={{ paddingLeft: "10px" }}>
                          <h4 className="welcome-user-details mobile-data">
                            {t("Your Harinaam Sankirtan Count")}
                          </h4>
                          <p className="welcome-user-count">
                            {userEventRanking?.count_book
                              ? Math.ceil(
                                userEventRanking?.count_book
                              ).toLocaleString("en-IN")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-md-6 mb-4">
                      <div className="d-flex align-items-center mt-3">
                        {/* India: Harinaam Sankirtan */}
                        <svg
                          width="88"
                          height="88"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.21"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
                            fill="#3DCFCF"
                          />
                          <path
                            d="M19.1111 40.8889H42.4444C43.3036 40.8889 44 41.5853 44 42.4444C44 43.3036 43.3036 44 42.4444 44H17.5556C16.6964 44 16 43.3036 16 42.4444V17.5556C16 16.6964 16.6964 16 17.5556 16C18.4147 16 19.1111 16.6964 19.1111 17.5556V40.8889Z"
                            fill="#3DCFCF"
                          />
                          <path
                            opacity="0.5"
                            d="M24.9126 34.175C24.325 34.8018 23.3406 34.8335 22.7138 34.2459C22.0871 33.6584 22.0553 32.674 22.6429 32.0472L28.4762 25.825C29.0445 25.2188 29.9888 25.1663 30.6208 25.7056L35.2248 29.6344L41.2235 22.0361C41.7558 21.3618 42.734 21.2467 43.4083 21.7791C44.0826 22.3114 44.1977 23.2896 43.6653 23.9639L36.6653 32.8306C36.1186 33.5231 35.1059 33.6227 34.4347 33.05L29.7306 29.0358L24.9126 34.175Z"
                            fill="#3DCFCF"
                          />
                        </svg>
                        <div className="mt-2" style={{ paddingLeft: "10px" }}>
                          <h4 className="welcome-user-details mobile-data">
                            {t("India: Harinaam Sankirtan Count")}
                          </h4>
                          <p className="welcome-user-count">
                            {indiaPledgeData?.total_count_book_for_score
                              ? Math.ceil(
                                indiaPledgeData?.total_count_book_for_score
                              ).toLocaleString("en-IN")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>

            <div className="col-md-8 welcome-right ">
              <div className="row user-welcome-card right-section progress-parent-mobile">
                <div className="col-md-12 welcome-right">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-8 mb-3 mb-md-0">
                      <h5 style={{ color: "#1E1F21", marginBottom: 0 }}>
                        {t("Harinaam Sankirtan For Your Temple")}
                      </h5>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-12 d-flex justify-content-end align-items-end">

                          {/* <div className="position-relative flex-grow-1">

                            <MobileSafeDatePicker
                              value={sankirtanaFilterDate}
                              onChange={(val) => setSankirtanaFilterDate(val)}
                              placeholder={t("Select Date Filter")}
                            />


                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-secondary ms-2"
                            onClick={() => setSankirtanaFilterDate("")}
                            style={{ height: "38px", backgroundColor: "#9F1D21", color: "#FFFFFF" }}
                          >
                            {t("Reset")}
                          </button> */}

                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="table-responsive"
                    style={{ maxHeight: "250px", overflowY: "auto" }} // Enable vertical scrolling
                  >
                    <table className="custom-sankirtan-table">
                      <thead className="table-light">
                        <tr>
                          <th>{t("Date")}</th>
                          <th>{t("Duration of Sankirtan")}</th>
                          <th>
                            <span className="participants-header">
                              {isMobile ? t("Participants/Photos") : t("Participants")}
                            </span>

                          </th>
                          <th className="desktop-only">{t("Photos")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sankirtanaData?.length > 0
                          ? sankirtanaData
                            .filter((item) =>
                              sankirtanaFilterDate
                                ? new Date(item.sankirtan_date)
                                  .toISOString()
                                  .split("T")[0] === sankirtanaFilterDate
                                : true
                            )
                            .map((item, index) => (
                              <tr key={index}>
                                <td>
                                  {new Date(item.sankirtan_date).toISOString().split("T")[0]
                                    .split("-")
                                    .reverse()
                                    .join("-")}
                                </td>
                                <td>{item.duration || "-"}</td>
                                <td className="view-btn-column">
                                  <div className="view-btn-wrapper">
                                    <span>{item.participants}</span>

                                    {item.photo_files && item.photo_files.length > 0 ? (
                                      <button
                                        onClick={() => handleOpenModal(item.photo_files)}
                                        className="mobile-only view-button"
                                      >
                                        View
                                      </button>
                                    ) : (
                                      <span className="mobile-only no-photo-text">(No Photos)</span>
                                    )}
                                  </div>
                                </td>
                                <td className="desktop-only">
                                  <div className="view-btn-wrapper">
                                    <span>{item.photo_files ? item.photo_files.length : "No Photos"}</span>

                                    {item.photo_files && item.photo_files.length > 0 && (
                                      <button
                                        onClick={() => handleOpenModal(item.photo_files)}
                                        className="view-button"
                                      >
                                        View
                                      </button>
                                    )}
                                  </div>
                                </td>

                              </tr>
                            ))
                          : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                {filterType === "date"
                                  ? "No Harinaam Sankirtan Score updated"
                                  : filterType === "temple"
                                    ? "No Harinaam Sankirtan Score updated for this temple"
                                    : filterType === "date-temple"
                                      ? "No Harinaam Sankirtan Score updated for this date and temple"
                                      : "No Harinaam Sankirtan Score updated"}
                              </td>
                            </tr>
                          )}
                        <Modal
                          show={showModal}
                          onHide={handleCloseModal}
                          size="lg"
                          centered
                          backdropClassName="custom-backdrop"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Images</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                              {selectedImages.map((file, index) => (
                                <img
                                  key={index}
                                  src={file}
                                  alt={`image-${index}`}
                                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                                />
                              ))}
                            </div>
                          </Modal.Body>
                        </Modal>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 welcome-right mt-4">
              <div className="row user-welcome-card right-section progress-parent-mobile">
                <div className="col-md-12 welcome-right">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-8 mb-3 mb-md-0">
                      <h5 style={{ color: "#1E1F21", marginBottom: 0, fontSize: '18px' }}>
                        {t("Harinaam Sankirtan All India Level")}
                      </h5>
                    </div>
                    <div className="col-md-4">
                      {/* <div className="row">
                        <div className="col-md-12 d-flex justify-content-end align-items-end">

                          <div className="position-relative flex-grow-1">

                            <MobileSafeDatePicker
                              value={sankirtanaFilterDateAll}
                              onChange={(val) => setSankirtanaFilterDateAll(val)}
                              placeholder={t("Select Date Filter")}
                            />


                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-secondary ms-2"
                            onClick={() => setSankirtanaFilterDateAll("")}
                            style={{ height: "38px", backgroundColor: "#9F1D21", color: "#FFFFFF" }}
                          >
                            {t("Reset")}
                          </button>

                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div
                    className="table-responsive"
                    style={{ maxHeight: "200px", overflowY: "auto" }} // Enable vertical scrolling
                  >
                    <table className="custom-sankirtan-table">
                      <thead className="table-light">
                        <tr>
                          <th>{t("Date")}</th>
                          <th>{t("Temples")}</th>
                          {/* <th>{t("Duration of Sankirtan")}</th> */}
                          <th>
                            <span className="participants-header">
                              {isMobile ? t("Participants/Photos") : t("Participants")}
                            </span>
                          </th>
                          <th className="desktop-only">{t("Photos")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sankirtanaDataAllTemples?.length > 0
                          ? sankirtanaDataAllTemples
                            .filter((item) =>
                              sankirtanaFilterDateAll
                                ? new Date(item.sankirtan_date)
                                  .toISOString()
                                  .split("T")[0] === sankirtanaFilterDateAll
                                : true
                            )
                            .map((item, index) => (
                              <tr key={index}>
                                <td>
                                  {new Date(item.sankirtan_date).toISOString().split("T")[0]
                                    .split("-")
                                    .reverse()
                                    .join("-")}
                                </td>
                                <td className="small-wrap">{item.temple_name || "-"}</td>
                                {/* <td>{item.duration || "-"}</td> */}
                                <td className="view-btn-column">
                                  <div className="view-btn-wrapper">
                                    <span>{item.participants}</span>

                                    {item.photo_files && item.photo_files.length > 0 ? (
                                      <button
                                        onClick={() => handleOpenModal(item.photo_files)}
                                        className="mobile-only view-button"
                                      >
                                        View
                                      </button>
                                    ) : (
                                      <span className="mobile-only no-photo-text">(No Photos)</span>
                                    )}
                                  </div>
                                </td>

                                <td className="desktop-only">
                                  <div className="view-btn-wrapper">
                                    <span>{item.photo_files ? item.photo_files.length : "No Photos"}</span>

                                    {item.photo_files && item.photo_files.length > 0 && (
                                      <button
                                        onClick={() => handleOpenModal(item.photo_files)}
                                        className="view-button"
                                      >
                                        View
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                {filterType === "date"
                                  ? "No Harinaam Sankirtan updated"
                                  : filterType === "temple"
                                    ? "No Harinaam Sankirtan updated for this temple"
                                    : filterType === "date-temple"
                                      ? "No Harinaam Sankirtan updated for this date and temple"
                                      : "No Harinaam Sankirtan updated"}
                              </td>
                            </tr>
                          )}
                        <Modal
                          show={showModal}
                          onHide={handleCloseModal}
                          size="lg"
                          centered
                          backdropClassName="custom-backdrop"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Images</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                              {selectedImages.map((file, index) => (
                                <img
                                  key={index}
                                  src={file}
                                  alt={`image-${index}`}
                                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                                />
                              ))}
                            </div>
                          </Modal.Body>
                        </Modal>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 welcome-right mt-4">
              <div className="row user-welcome-card right-section progress-parent-mobile">
                <div className="col-md-12 welcome-right">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-4 mb-3 mb-md-0">
                      <h5 style={{ color: "#1E1F21", marginBottom: 0, fontSize: '18px' }}>
                        {t("Upcoming Sankirtan")}
                      </h5>
                    </div>

                    <div className="col-md-8">
                      {/* <div className="row">
                          <div className="col-md-6 d-flex align-items-center mb-2 mb-md-0">
                            <div className="position-relative flex-grow-1 me-2">

                              <MobileSafeDatePicker
                                value={filterDate}
                                onChange={(val) => setFilterDate(val)}
                                placeholder={t("Select Date Filter")}
                              />


                            </div>

                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setFilterDate("")}
                              style={{ height: "38px", backgroundColor: "#9F1D21", color: "#FFFFFF" }}
                              disabled={!filterDate}
                            >
                              {t("Reset")}
                            </button>
                          </div>

                          <div className="col-md-6 d-flex align-items-center mb-2 mb-md-0">
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              value={filterTemple}
                              onChange={(e) => setFilterTemple(e.target.value)}
                              placeholder={t("Search Temple")}
                              style={{ color: "#43567D", fontSize:'14px'}}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary ms-2"
                              onClick={() => setFilterTemple("")}
                              title="Reset Temple Filter"
                              style={{ height: "38px", backgroundColor: "#9F1D21", color: "#FFFFFF" }}
                            >
                              {t("Reset")}
                            </button>
                          </div>
                        </div> */}
                    </div>
                  </div>

                  <div
                    className="table-responsive"
                    style={{ height: "200px", overflowY: "auto" }} // Enable vertical scrolling
                  >
                    <table className="custom-sankirtan-table">
                      <thead className="table-light">
                        <tr>
                          <th>{t("Date")}</th>
                          <th>{t("Temples")}</th>
                          <th>{t("Location")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredSchedules?.length > 0 ? (
                          filteredSchedules.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {new Date(item.date).toISOString().split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join("-")}</td>
                              <td className="small-wrap">{item.temple || "-"}</td>
                              <td>{item.location || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center">
                              {filterType === "date"
                                ? "No upcoming schedules for this date"
                                : filterType === "temple"
                                  ? "No upcoming schedules for this temple"
                                  : filterType === "date-temple"
                                    ? "No upcoming schedules for this date and temple"
                                    : "No upcoming schedules"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>


          </div>
        )}
        {/* GBC Login stats */}
        {user?.role == "GBC (Governing Body Commission)" && (
          <>
            <div className="row">
              <div className="col-md-12 user-welcome-card">
                <p className="welcome-text-name">
                  {t("Welcome")}{" "}
                  {i18n.language === "hi" ? user?.hindiname : user?.name}
                </p>
                <p className="welcome-info-text">
                  {t(
                    "This page provides a comprehensive overview of performance metrics for temples across India, categorized by events, zones, and states."
                  )}
                </p>
              </div>
            </div>
            {typeof indiaPledgeData?.india_pledge_percentage != "undefined" && (
              <div className="row mt-4">
                <div className="col-md-12 user-welcome-card">
                  <div className="gbc-pledge-covered-card">
                    <div className="gbc-items">
                      <h4 className="user-pledge-covered">
                        {t("Pledge Covered")}
                      </h4>
                      <small className="pledge-status-text">
                        {t("India's pledge completion status")}
                      </small>
                    </div>
                    <div className="gbc-items gbc-pledge-div">
                      <div className="gbc-india-score-input">
                        <input
                          type="radio"
                          className="india-input"
                          checked
                          readOnly
                        />
                        <p className="progress-count">
                          {indiaPledgeData?.india_pledge_percentage}%
                        </p>
                        <p className="progress-count-text-india">
                          {t("India's Score")}
                        </p>
                      </div>
                      <CommonProgressBar
                        animatedPercentage={
                          indiaPledgeData?.india_pledge_percentage
                        }
                        type={"gbc-india-progress"}
                        selectedEvent={""}
                      />
                    </div>
                    <div className="gbc-items">
                      <div className="d-flex align-items-center gbc-india-pledge-mobile">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.21"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
                            fill="#3DCFCF"
                          />
                          <path
                            opacity="0.587821"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M20.6667 23.3333C20.6667 26.2789 23.0546 28.6667 26.0001 28.6667C28.9456 28.6667 31.3334 26.2789 31.3334 23.3333C31.3334 20.3878 28.9456 18 26.0001 18C23.0546 18 20.6667 20.3878 20.6667 23.3333ZM34.0001 28.6667C34.0001 30.8758 35.7909 32.6667 38.0001 32.6667C40.2092 32.6667 42.0001 30.8758 42.0001 28.6667C42.0001 26.4575 40.2092 24.6667 38.0001 24.6667C35.7909 24.6667 34.0001 26.4575 34.0001 28.6667Z"
                            fill="#3DCFCF"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M25.9778 31.3333C19.6826 31.3333 14.5177 34.5687 14.0009 40.9323C13.9727 41.2789 14.6356 42 14.97 42H36.9956C37.9972 42 38.0128 41.194 37.9972 40.9333C37.6065 34.3909 32.3616 31.3333 25.9778 31.3333ZM45.2746 42L40.1333 42C40.1333 38.9988 39.1417 36.2291 37.4683 34.0008C42.0103 34.0505 45.7189 36.3469 45.998 41.2C46.0092 41.3955 45.998 42 45.2746 42Z"
                            fill="#3DCFCF"
                          />
                        </svg>

                        <div style={{ paddingLeft: "10px" }}>
                          <h4 className="welcome-user-details mobile-data">
                            {t("India: Pledge")}
                          </h4>
                          <p className="welcome-user-count">
                            {indiaPledgeData?.total_count_book_for_pledge
                              ? Math.ceil(
                                indiaPledgeData?.total_count_book_for_pledge
                              ).toLocaleString("en-IN")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="gbc-items">
                      <div className="d-flex align-items-center">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.21"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
                            fill="#3DCFCF"
                          />

                          <path
                            d="M19.1111 40.8889H42.4444C43.3036 40.8889 44 41.5853 44 42.4444C44 43.3036 43.3036 44 42.4444 44H17.5556C16.6964 44 16 43.3036 16 42.4444V17.5556C16 16.6964 16.6964 16 17.5556 16C18.4147 16 19.1111 16.6964 19.1111 17.5556V40.8889Z"
                            fill="#3DCFCF"
                          />
                          <path
                            opacity="0.5"
                            d="M24.9126 34.175C24.325 34.8018 23.3406 34.8335 22.7138 34.2459C22.0871 33.6584 22.0553 32.674 22.6429 32.0472L28.4762 25.825C29.0445 25.2188 29.9888 25.1663 30.6208 25.7056L35.2248 29.6344L41.2235 22.0361C41.7558 21.3618 42.734 21.2467 43.4083 21.7791C44.0826 22.3114 44.1977 23.2896 43.6653 23.9639L36.6653 32.8306C36.1186 33.5231 35.1059 33.6227 34.4347 33.05L29.7306 29.0358L24.9126 34.175Z"
                            fill="#3DCFCF"
                          />
                        </svg>

                        <div style={{ paddingLeft: "10px" }}>
                          <h4 className="welcome-user-details">
                            {t("India: Books Distributed")}
                          </h4>
                          <p className="welcome-user-count">
                            {indiaPledgeData?.total_count_book_for_score
                              ? Math.ceil(
                                indiaPledgeData?.total_count_book_for_score
                              ).toLocaleString("en-IN")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="gbc-items">
                      <div className="d-flex align-items-center">
                        <div className="gbc-india-points-div">
                          <img
                            src="/images/common/india-points-image.png"
                            height={30}
                            width={30}
                            className="margin-image"
                          />
                        </div>
                        <div style={{ paddingLeft: "10px" }}>
                          <h4 className="welcome-user-details">
                            {t("India: Book Points")}
                          </h4>
                          <p className="welcome-user-count">
                            {indiaPledgeData?.total_points_for_score
                              ? Math.ceil(
                                indiaPledgeData?.total_points_for_score
                              ).toLocaleString("en-IN")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {/* Event tabs */}
        {/* <div className="row mt-4">
          <div className="col-md-12">
            <h4 className="welcome-text">
              {user?.role != "GBC (Governing Body Commission)" &&
              user?.role != "Regional Zonal Secretary" &&
              user?.role !== "Regional Secretary Assistant"
                ? t("")
                : t("Event Wise Dashboard")}
            </h4>
            <div className="ranking-filters mt-4">
              <div className="tabs-wrapper">
                {selectTabs.map((item, i) => (
                  <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={tooltip(item.description)}>
                    <div className="event-div" key={i}>
                      <div
                        className={"select-tab-div " + (selectedEvent == item.value ? " active-tab" : "")}
                        onClick={() => setSelectedEvent(item.value)}
                      >
                        <span className={selectedEvent == item.value ? "tab-event-text-active" : "tab-event-text"}>{item.label}</span>
                      </div>
                    </div>
                  </OverlayTrigger>
                ))}
              </div>
            </div>
          </div>
        </div> */}

        {/* User Graphs*/}
        {user?.role != "GBC (Governing Body Commission)" &&
          user?.role != "Regional Zonal Secretary" &&
          user?.role != "Regional Secretary Assistant" && (
            <TempleDashboard
              selectedEvent={selectedEvent}
              userBooksStatsData={userBooksStatsData}
              overAllPointsCount={overAllPointsCount}
              userEventRanking={userEventRanking}
              previousYearUserEventRanking={previousYearUserEventRanking}
              topTemplesList={topTemplesList}
              user={user}
              monthlyPoints={monthlyPoints}
              yearlyPoints={yearlyPoints}
            />
          )}

        {/* GBC Graphs*/}
        {/* {user?.role == "GBC (Governing Body Commission)" && (
          <GBCDashboard
            selectedEvent={selectedEvent}
            topTemplesList={topTemplesList}
            user={user}
          />
        )} */}

        {/* RSA Graphs*/}
        {/* {user?.role == "Regional Zonal Secretary" ||
          (user?.role == "Regional Secretary Assistant" && (
            <RSADashboard
              selectedEvent={selectedEvent}
              userBooksStatsData={userBooksStatsData}
              overAllPointsCount={overAllPointsCount}
              userEventRanking={userEventRanking}
              previousYearUserEventRanking={previousYearUserEventRanking}
              topTemplesList={topTemplesList}
              user={user}
            />
          ))} */}
      </div>
    </div>
  );
};

export default Dashboard;
